import angular from 'angular';

/**
 * Controla el diálogo de rechazar tarea.
 */
AddEditEntidadEnvioDialogCtrl.$inject = ['$log', '$scope', '$filter'];

export default function AddEditEntidadEnvioDialogCtrl($log, $scope, $filter) {

    var entidad = $scope.model.entidad;

    $scope.esAdd = !angular.isDefined($scope.model.id);
    $scope.esEdit = angular.isDefined($scope.model.id);

    $scope.model.apertura_expediente = $scope.model.apertura_expediente == 1;

    $scope.mostrarCrearAlarm = false;
    $scope.hayAlarma = angular.isDefined($scope.model.alarma_id) && angular.isNumber($scope.model.alarma_id);

    if ($scope.esAdd) {
        $scope.model.recibida_respuesta = false;
        $scope.model.enviar_mail = true;
        $scope.model.crear_alarma = entidad.accede_a_backoffice == 0 && entidad.monitorizar_respuestas == 1 && entidad.dias_alarma > 0;
        $scope.mostrarCrearAlarm = entidad.accede_a_backoffice == 0 && entidad.monitorizar_respuestas == 1 && entidad.dias_alarma > 0;
    } else {
        $scope.model.enviar_mail = $scope.model.enviar_mail == 1;
        $scope.model.crear_alarma = $scope.model.crear_alarma == 1;
        $scope.model.recibida_respuesta = $scope.model.recibida_respuesta == 1;
        $scope.mostrarCrearAlarm = $scope.hayAlarma && !$scope.model.recibida_respuesta && $scope.model.alarma.notificada == 0;
        if (issetAndNotEmpty($scope.model.fecha_respuesta)) {
            if ($scope.model.fecha_respuesta == '0000-00-00 00:00:00') {
                $scope.model.fecha_respuesta = '';
            } else {
                $scope.model.fecha_respuesta = $filter('formatDate')($scope.model.fecha_respuesta);
            }
        }
    }

    $scope.aLasDoce = function () {
        if ($scope.model.fecha_respuesta instanceof Date) {
            $scope.model.fecha_respuesta.setHours(13);
            $scope.model.fecha_respuesta.setMinutes(0);
            $scope.model.fecha_respuesta.setSeconds(0);
        }
    }

}